import { render, staticRenderFns } from "./UnitDetail.vue?vue&type=template&id=446042a5&"
import script from "./UnitDetail.vue?vue&type=script&lang=ts&"
export * from "./UnitDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('446042a5')) {
      api.createRecord('446042a5', component.options)
    } else {
      api.reload('446042a5', component.options)
    }
    module.hot.accept("./UnitDetail.vue?vue&type=template&id=446042a5&", function () {
      api.rerender('446042a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnitDetail.vue"
export default component.exports